module.exports = __webpack_public_path__ + "static/media/3.869a5bb0.jpg";